import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

// ui components
import { Sidebar } from "primereact/sidebar";

// css
import "./Navbar.css";
import "./../../../assets/css/hamburgers.css";

// images
import MTN_LOGO from "./../../../assets/images/mtn-logo-nav.svg";

// icons
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PersonIcon from "@mui/icons-material/Person";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

const Navbar = () => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="sticky top-0 w-full h-16 bg-jaune-mtn z-50">
      <div className="flex min-w-fit px-3 sm:px-10 mx-auto h-full flex items-center justify-between">
        <div className="w-full flex items-center gap-x-5 sm:gap-x-10">
          <Link to="/">
            <img
              src={MTN_LOGO}
              alt="Logo mtn"
              className="w-20 md:w-28"
            />
          </Link>
          {/* <div className="w-full flex items-center justify-center gap-x-10 -ml-16">
            <NavLink to="/accueil">
              <p className="font-bold">Accueil</p>
            </NavLink>
            <NavLink to="/forfaits">
              <p className="font-bold">Forfait</p>
            </NavLink>
            <div className="dropdown">
              <label
                tabIndex="0"
                className=" bg-white font-bold px-2 pr-px flex items-center justify-between cursor-pointer"
              >
                <span className="font-brightersans">Personal</span>
                <KeyboardArrowDownIcon className="ml-1" />
              </label>
              <ul
                tabIndex="0"
                className="dropdown-menu dropdown-content menu p-2 shadow bg-base-100 rounded-xl w mt-2"
              >
                <li className="rounded-md">
                  <a>Item 1</a>
                </li>
                <li className="rounded-md">
                  <a>Item 2</a>
                </li>
              </ul>
            </div>
            <div className="dropdown">
              <label
                tabIndex="0"
                className="font-bold px-2 pr-px flex items-center justify-between cursor-pointer"
              >
                <span className="font-brightersans">Business</span>
                <KeyboardArrowDownIcon className="ml-1" />
              </label>
              <ul
                tabIndex="0"
                className="dropdown-menu dropdown-content menu p-2 shadow bg-base-100 rounded-xl w-52 mt-2"
              >
                <li className="rounded-md">
                  <a>Item 1</a>
                </li>
                <li className="rounded-md">
                  <a>Item 2</a>
                </li>
              </ul>
            </div>
            <div className="dropdown">
              <label
                tabIndex="0"
                className="font-bold px-2 pr-px flex items-center justify-between cursor-pointer"
              >
                <span className="font-brightersans">MoMo</span>
                <KeyboardArrowDownIcon className="ml-1" />
              </label>
              <ul
                tabIndex="0"
                className="dropdown-menu dropdown-content menu p-2 shadow bg-base-100 rounded-xl w-52 mt-2"
              >
                <li className="rounded-md">
                  <a>Item 1</a>
                </li>
                <li className="rounded-md">
                  <a>Item 2</a>
                </li>
              </ul>
            </div>
          </div> */}
        </div>
        <div className="flex items-center gap-x-10">
          <NavLink to="/compte/profil">
            <div className="flex flex-col items-center">
              <PersonIcon sx={{ fontSize: 27 }} />
              <span className="text-sm font-medium font-brightersans">
                Profil
              </span>
            </div>
          </NavLink>
          {/* <div className="flex flex-col items-center">
            <ShoppingCartIcon sx={{ fontSize: 27 }} />
            <span className="text-sm font-normal font-brightersans">Cart</span>
          </div> */}
        </div>
      </div>

      <div className="w-11/12 mx-auto h-full hidden items-center justify-between">
        <Link to="/">
          <img
            src={MTN_LOGO}
            alt="Logo mtn"
            className="w-10 border-2 border-white"
          />
        </Link>
        <button
          className={
            visible
              ? "mt-1 hamburger hamburger--collapse is-active"
              : "mt-1 hamburger hamburger--collapse"
          }
          type="button"
          onClick={(e) => setVisible(true)}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </button>
      </div>

      <Sidebar visible={visible} onHide={() => setVisible(false)}>
        <div className="flex flex-col items-start gap-y-">
          <div className="w-full border-t border-b py-2">
            <div className="dropdown w-full">
              <label
                tabIndex="0"
                className="py-3 text-black font-bold px-2 pr-px flex items-center justify-between cursor-pointer"
              >
                <span className="text-lg font-brightersans">Personal</span>
                <KeyboardArrowDownIcon className="ml-1" />
              </label>
              <ul
                tabIndex="0"
                className="w-full border dropdown-menu dropdown-content menu p-2 shadow bg-base-100 rounded-xl w-64 mt-2"
              >
                <li className="rounded-md">
                  <a>Item 1</a>
                </li>
                <li className="rounded-md">
                  <a>Item 2</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="w-full py-2">
            <div className="dropdown w-full">
              <label
                tabIndex="0"
                className="py-3 text-black font-bold px-2 pr-px flex items-center justify-between cursor-pointer"
              >
                <span className="text-lg font-brightersans">Business</span>
                <KeyboardArrowDownIcon className="ml-1" />
              </label>
              <ul
                tabIndex="0"
                className="w-full border dropdown-menu dropdown-content menu p-2 shadow bg-base-100 rounded-xl w-64 mt-2"
              >
                <li className="rounded-md">
                  <a>Item 1</a>
                </li>
                <li className="rounded-md">
                  <a>Item 2</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="w-full border-t border-b py-2">
            <div className="dropdown w-full">
              <label
                tabIndex="0"
                className="py-3 text-black font-bold px-2 pr-px flex items-center justify-between cursor-pointer"
              >
                <span className="text-lg font-brightersans">MoMo</span>
                <KeyboardArrowDownIcon className="ml-1" />
              </label>
              <ul
                tabIndex="0"
                className="w-full border dropdown-menu dropdown-content menu p-2 shadow bg-base-100 rounded-xl w-64 mt-2"
              >
                <li className="rounded-md">
                  <a>Item 1</a>
                </li>
                <li className="rounded-md">
                  <a>Item 2</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <div className="flex items-center gap-x-2 text-black py-4 border-b">
            <PersonIcon sx={{ fontSize: 35 }} />
            <span className="text-lg font-medium font-brightersans">
              Profil
            </span>
          </div>
          <div className="flex  items-center gap-x-2 text-black py-4 border-b">
            <ShoppingCartIcon sx={{ fontSize: 35 }} />
            <span className="text-lg font-medium font-brightersans">Cart</span>
          </div>
        </div>
      </Sidebar>
    </div>
  );
};

export default Navbar;
